<template>
  <div class="bb-notifications-bar-main-client">
    <div
      v-if="index < list.length - 1"
      v-for="(item, index) in list"
      :key="index"
      class="bb-notifications-bar-main-client-item"
    >
      <div class="bb-notifications-bar-main-client-item__description">
        {{item.key}}
      </div>
      <div :class="[
          'bb-notifications-bar-main-client-item__description',
          'bb-notifications-bar-main-client-item__description_light',
        ]"
      >
        {{item.description}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationsBarMainClient',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    keys: [
      'Project manager:',
      'Company name:',
      'Client nickname:',
      'Formed in:'
    ]
  }),
  computed: {
    list () {
      const { comment } = this.item
      const description = comment.split(',').map((el, index) => {
        return {
          key: this.keys[index],
          description: el
        }
      })
      return description
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bb-notifications-bar-main-client {
    display: grid;
    grid-gap: 4px 0;

    &-item {
      display: grid;
      grid-template-columns: 107px 203px;
      align-items: center;

      &__description {
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;

        &_light {
          font-weight: 300;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsBar/NotificationsBarMainClient.vue